import {
  InterfaceSettings,
  FieldGroup,
  FieldConfig,
  I18nDescribable,
  IEvaluableExecutor
} from '../../api/contract-notice-dto';
import {
  ValidatorFn,
  AsyncValidatorFn,
  ValidationErrors
} from '@angular/forms';
import { Observable, of } from 'rxjs';
import { HelpService } from '../common/help/help.service';
import { ServiceLocator } from '../../ServiceLocator';
import { TemplateRef } from '@angular/core';
import { map, switchMap } from 'rxjs/operators';

// TODO mover InterfaceSettings, FieldGroup y FieldConfig

/**
 * Interface a implementar con el envio de un formulario al servidor
 *
 * actionId: Proporciona el dentificador de la accion ejecutada en caso de existir varias.
 * buttonTextKey: clave del texto internacionalizado que se utilizará para el boton del formulario que ejecutara la accion
 * buttonClass: clasae CSS que se asignará al boton del formulario
 * closeOnSuccess: En caso de formularios que se abren en un dialogo indica si se debe cerrar el formulario
 *                tras ejecutar la acción correctamente
 * executeFormAction: Funcion a ejecutar en el click del boton
 */
export interface FormAction<T> {
  actionId: string;
  buttonTextKey: string;
  buttonClass: string;
  imageClass: string;
  closeOnSuccess: boolean;
  visibility: any;
  executeFormAction(model: T): Observable<any>;
}

export class CancelFormAction implements FormAction<any> {
  visibility = true;
  actionId = 'cancel';
  buttonTextKey = 'General.cancel';
  buttonClass = 'btn btn-secondary';
  imageClass = 'fas fa-times';
  closeOnSuccess = true;
  executeFormAction(model: any): Observable<any> {
    return of(model);
  }
}

export class CloseFormAction implements FormAction<any> {
  visibility = true;
  actionId = 'close';
  buttonTextKey = 'General.close';
  buttonClass = 'btn btn-secondary';
  imageClass = 'fas fa-times';
  closeOnSuccess = true;
  executeFormAction(model: any): Observable<any> {
    return of(model);
  }
}

export class AcceptFormAction implements FormAction<any> {
  visibility = true;
  actionId = 'accept';
  buttonTextKey = 'General.accept';
  buttonClass = 'btn btn-primary';
  imageClass = 'fa fa-check';
  closeOnSuccess = true;
  executeFormAction(model: any): Observable<any> {
    return of(model);
  }
}
export class BaseFormAction implements FormAction<any> {
  /*actionId = 'save';
  buttonTextKey = 'General.save';
  buttonClass = 'btn btn-primary';
  imageClass = 'fa fa-check';
  closeOnSuccess = true;*/
  executeFormAction(model: any): Observable<any> {
    return of(this.action.call(this, model));
  }
  constructor(public actionId: string,
    public buttonTextKey: string, public buttonClass: string, public imageClass,
    public closeOnSuccess: boolean,
    public action: Function,
    public visibility: any) {
    // this.visibility = true;
    if (visibility == undefined) {
      this.visibility = true;
    };



  }

}

/**
 * Datos que devuelve un formulario de plyca formPlycaComponent al ser invocado mediante un dialogo DialogService
 *
 * actionId: Proporciona el dentificador de la accion ejecutada en caso de existir varias.
 * model: Proporciona el modelo final modificado por el componente formPlycaComponent
 */
export class FormDialogResponse<T> {
  actionId: string;
  model: T;
}

/**
 * Clase que contiene la informacion de un formulario completo: interface, accion asociada y modelo
 */
export class FormConfig {
  readonly: boolean;
  interfaceSetting: InterfaceSettings;
  actions: Array<FormAction<any>>;
  model: any;
  showContentIndex: boolean;
  showValidations: boolean;
  interfaceSettingsId: string;
  baseInterfaceSettingsId: string;
  functions: Array<FunctionDef>;
  templates: Array<TemplateDef>;
  /* TODO-AYUDA-MODAL-FORM Se está cargando la info de la ayuda contextual en modales, Pendiente de pintar en subheader */
  protected helpService: HelpService;
  parentHelpTags: string[];
  searchTags: string[];
  isModalWindow: boolean;
  windowHash: string;


  public static destroy(config: FormConfig): void {
    // eliminar propiedades que puedan generar dependencias circulares
    if (config) {
      config.functions = undefined;
      config.templates = undefined;
      config.actions = undefined;
    }
  }

  /* FIN TODO-AYUDA-MODAL-FORM */
  constructor(// Cuando se establece un  formlario con interfaceSettings preconfigurado, se pone un valor en el base para poder definir el id de ayuda
    baseInterfaceSettingsId: string, // Por defecto undefined, para que funcione la ayuda cuando no hay interfaceSettingsId
    interfaceSettingsId: string,
    model: any = {},
    actions?: Array<FormAction<any>>,
    showValidations?: boolean,
    showContentIndex?: boolean,
    searchTags?: string[],
    readonly?: boolean
  ) {
    /* INI TODO-AYUDA-MODAL-FORM Se está cargando la info de la ayuda contextual en modales, Pendiente de pintar en subheader */
    this.helpService = ServiceLocator.injector.get(HelpService);

    /* FIN TODO-AYUDA-MODAL-FORM */
    this.interfaceSettingsId = interfaceSettingsId;
    this.baseInterfaceSettingsId = baseInterfaceSettingsId;
    this.actions = actions;
    this.model = model;
    this.functions = [];
    this.templates = [];
    if (showValidations === undefined) {
      this.showValidations = false;
    }
    if (showContentIndex === undefined) {
      this.showContentIndex = false;
    }
    if (readonly === undefined) {
      this.readonly = false;
    } else {
      this.readonly = readonly;
    }
    /* INI TODO-AYUDA-MODAL-FORM Se está cargando la info de la ayuda contextual en modales, Pendiente de pintar en subheader */

    this.helpService.getStoreTagsObservable().pipe(
      switchMap((helpTags) => {
        this.parentHelpTags = helpTags;
        let obs: Observable<any>;

        if (searchTags === undefined) {
          this.searchTags = [];
          obs = of(true);
        } else {
          this.searchTags = searchTags;
          obs = this.helpService.showContextHelpObservable(searchTags).pipe(
            map(() => helpTags)
          )
        }
        return obs;
      })).subscribe();

    /* FIN TODO-AYUDA-MODAL-FORM */

    // if (!this.action) {
    //   throw new Error(
    //     'Error de configuracion de formulario, no se ha indicado accion asociada'
    //   );
    // }
  }
}

/**
 * Clase de utilidad para configuracion de formularios
 */
export interface FormConfigHelper {
  /**
   * Metodo que permite registrar funciones de apoyo a un formulario en una clase independiente
   *
   * @param frmConfig Objeto sobre el que registrar funciones
   */
  registerFunctions(frmConfig: FormConfig): void;
}

export class FormGroupConfig {
  readonly: boolean;
  group: FieldGroup;
  model: any;
  visibility: string;
  functions: Array<FunctionDef>;
  templates: Array<TemplateDef>;
  syncValidationFn: ValidatorFn[];
  asyncValidationFn: AsyncValidatorFn[];

  constructor(
    group: FieldGroup,
    model: any = {},
    syncValidationFn?: ValidatorFn[],
    asyncValidationFn?: AsyncValidatorFn[],
    readonly?: boolean
  ) {
    this.group = group;
    this.model = model;
    this.functions = [];
    this.templates = [];
    this.syncValidationFn = syncValidationFn;
    this.asyncValidationFn = asyncValidationFn;
    this.visibility = group.visibility;
    if (readonly === undefined) {
      this.readonly = false;
    } else {
      this.readonly = readonly;
    }
    if (!this.group) {
      throw new Error(
        'Error de configuracion del grupo de campos del formulario, no se ha indicado campos asociados'
      );
    }
  }

}

export class FunctionDef {
  identifier: string;
  fn: Function;
}

export class TemplateDef {
  identifier: string;
  template: TemplateRef<any>;
}

// Clases de componente  ValidationResultComponent

export class ErrorForm {
  fieldGroups: ErrorFieldGroup[];
  unmappedErrors: ErrorDefinition[];

  constructor(formConfig: FormConfig) {
    let groups = formConfig.interfaceSetting.fieldGroups
    this.unmappedErrors = new Array<ErrorDefinition>();
    this.fieldGroups = new Array<ErrorFieldGroup>();
    groups.forEach((groupConfig: FieldGroup) =>
      this.fieldGroups.push(new ErrorFieldGroup(groupConfig, formConfig.model, formConfig.functions))
    );
  }

  hasFieldErrors(): boolean {
    // let generalErrors = this.errors.filter((error: ErrorDefinition) => !type || error.type === type).length;
    return this.fieldGroups.some(
      (fieldGroup: ErrorFieldGroup) => fieldGroup.numberOfErrors() > 0
    );
  }

  hasUnmappedErrors(): boolean {
    // tslint:disable-next-line:triple-equals
    return (
      this.unmappedErrors &&
      this.unmappedErrors.some(
        (error: ErrorDefinition) => error.type != undefined
      )
    );
  }

  cleanErrors(): void {
    this.unmappedErrors = undefined;
    this.fieldGroups = [];
  }
}

export enum ERRORTYPE {
  EXCEPTION = 'EXCEPTION',
  ERROR = 'ERROR',
  FATAL = 'FATAL',
  WARNING = 'WARNING'
}

export function filterErrors(
  errorType: ERRORTYPE[],
  errorList: ValidationErrors
): any {
  let errors: any;
  let hasErrors: boolean;
  let auxValue: any;
  if (errorList) {
    errors = {} as any;
    if (errorType.indexOf(ERRORTYPE.FATAL) > -1) {
      // errores propios de angular
      auxValue = errorList.required;
      hasErrors = auxValue;
      if (auxValue) {
        errors.required = auxValue;
      }
      auxValue = errorList.minlength;
      hasErrors = hasErrors || auxValue;
      if (auxValue) {
        errors.minlength = auxValue;
      }
      auxValue = errorList.maxlength;
      hasErrors = hasErrors || auxValue;
      if (auxValue) {
        errors.maxlength = auxValue;
      }
      auxValue = errorList.email;
      hasErrors = hasErrors || auxValue;
      if (auxValue) {
        errors.email = auxValue;
      }
      auxValue = errorList.pattern;
      hasErrors = hasErrors || auxValue;
      if (auxValue) {
        errors.pattern = auxValue;
      }
    }
    auxValue = errorList.server;
    if (auxValue) {
      auxValue = auxValue.filter(
        (error: any) => errorType.indexOf(error.result) > -1
      );
      if (auxValue.length > 0) {
        errors.server = auxValue;
        hasErrors = true;
      }
    }
  }
  return hasErrors ? errors : undefined;
}

export class ErrorDefinition {
  type: ERRORTYPE;
  message: string;

  constructor(message: string, type: ERRORTYPE) {
    this.message = message;
    this.type = type;
  }
}

/**
 * Clase que contiene los errores asociados a un grupo
 * de campos de un formulario
 *
 * @field descriptionKey: descripcion del campo a internacionalizar
 * @field descriptionKeyExpression: Expresion con descripcion del campo
 * @field errors: mensajes de error asociados al campo
 * @field elementId: identificador del componente HTML asociado al campo
 */
export class ErrorField implements I18nDescribable, IEvaluableExecutor {
  descriptionKeyExpression: string;
  descriptionKey: string;
  description: any;
  errors: ErrorDefinition[];
  elementId: string;
  model: any;
  functions: FunctionDef[];
  _field: FieldConfig;
  constructor() {
    this.errors = new Array<ErrorDefinition>();
  }
}

/**
 * Clase que contiene los errores asociados a un grupo
 * de campos de un formulario
 * @field elementId: identificador del componente HTML asociado al grupo de campos
 * @field description: descripcion del formulario
 * @field fields: campos del formulario
 * @field errors: Errores generales no asociados a un campo del formulario
 */
export class ErrorFieldGroup implements I18nDescribable, IEvaluableExecutor {
  fieldGroup: FieldGroup
  elementId: string;
  description: string;
  descriptionKey: string;
  descriptionKeyExpression: string;
  model: any;
  functions: FunctionDef[];
  fields: ErrorField[];

  constructor(group: FieldGroup, model: any, functions: FunctionDef[]) {
    this.fieldGroup = group;
    this.description = group.description;
    this.descriptionKey = group.descriptionKey;
    this.descriptionKeyExpression = group.descriptionKeyExpression;
    this.model = model;
    this.functions = functions;
    this.elementId = group.id;
    this.fields = new Array<ErrorField>();
    group.fieldList
      .filter(
        (field: FieldConfig) =>
          field.abstractControl && field.abstractControl.errors
      )
      .forEach((field: FieldConfig) =>
        this.fields.push(this.toErrorField(field, model, functions))
      );
  }

  numberOfListOfErrors(types: ERRORTYPE[]): number {
    let errors = 0;
    types.forEach((type: ERRORTYPE) => errors += this.numberOfErrors(type));
    return errors;
  }

  numberOfErrors(type?: ERRORTYPE): number {
    let groupErrors = 0;
    this.fields
      .map(
        (field: ErrorField) =>
          field.errors.filter(
            (error: ErrorDefinition) => !type || error.type === type
          ).length
      )
      .forEach((value: number) => (groupErrors = groupErrors + value));
    return groupErrors;
  }

  private toErrorField(field: FieldConfig, model: any, functions: FunctionDef[]): ErrorField {
    let errorField = new ErrorField();
    errorField.elementId = field.jsonField;
    errorField.descriptionKeyExpression = field.descriptionKeyExpression;
    errorField.descriptionKey = field.descriptionKey;
    errorField.model = model;
    errorField.functions = functions;
    errorField._field = field;
    let formControl = field.abstractControl;
    if (formControl.errors.server) {
      field.abstractControl.errors.server.forEach((error: any) =>
        errorField.errors.push(new ErrorDefinition(error.message, error.result))
      );
    }
    if (formControl.errors.required) {
      errorField.errors.push(
        new ErrorDefinition('Forms.error.required', ERRORTYPE.ERROR)
      );
    }
    if (formControl.errors.minlength) {
      errorField.errors.push(
        new ErrorDefinition('Forms.error.minlength', ERRORTYPE.ERROR)
      );
    }
    if (formControl.errors.maxlength) {
      errorField.errors.push(
        new ErrorDefinition('Forms.error.maxlength', ERRORTYPE.ERROR)
      );
    }
    if (formControl.errors.email || formControl.errors.pattern) {
      errorField.errors.push(
        new ErrorDefinition('Forms.error.format', ERRORTYPE.ERROR)
      );
    }
    return errorField;
  }
}